// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/bundle." + {"15":"83ecf7efdc54b73be986","145":"6a43e1207ad7fc66e56e","216":"b71d32fddb84a9b69c40","234":"533a73e080bfe3a8d53d","300":"59ef3628b200ca1e8662","938":"bcb6d8a352d9bc68b448","999":"62fce4dcea41ebaf30a5"}[chunkId] + ".min.js";
};